import styled, { css } from 'styled-components';

import { Typography } from '@mixins';

export const Error = styled(Typography)`
${({ hasError }) => css`
  visibility: ${hasError ? 'visible' : 'hidden'};
  height: 8px;
`}`;
